import { memo } from "react";

import { BrandValuePropItem } from "@react/sections/ProductHero/BrandValueProps/BrandValuePropItem.view";
import { type BrandValueProp } from "@root/tablescape/state";
import { type TTailwindString, tw } from "classnames";

const styles = {
  valuePropsWrapper: tw("flex", "flex-row", "justify-around", "pb-6"),
  valuePropBox: tw(
    "text-center",
    "w-[109px]" as TTailwindString,
    "md:w-[154px]" as TTailwindString
  ),
  valuePropLink: tw("text-primary", "no-underline", "hover:underline"),
};

const BrandValuePropsBase = ({
  valueProps,
}: {
  valueProps: BrandValueProp[];
}) => {
  return (
    <div className={styles.valuePropsWrapper}>
      {valueProps.map((valueProp: BrandValueProp, index) => {
        return valueProp.url ? (
          <a
            className={tw(styles.valuePropLink, styles.valuePropBox)}
            href={valueProp.url}
            key={`value-prop-${index}-${valueProp.text}`}
          >
            <BrandValuePropItem valueProp={valueProp} />
          </a>
        ) : (
          <div
            className={styles.valuePropBox}
            key={`value-prop-${index}-${valueProp.text}`}
          >
            <BrandValuePropItem valueProp={valueProp} />
          </div>
        );
      })}
    </div>
  );
};

export const BrandValueProps = memo(BrandValuePropsBase);
